import { IFacetRadioGroupProps } from 'transfix-ui/components/FacetRadioGroup'
import {
  ISourceChannel,
  ISourceSegment,
  SOURCE_CHANNEL_LABELS,
  SOURCE_SEGMENT_LABELS,
} from '../../types'

export const TEST_IDS = {
  sourceChannelFacet: 'source-channel-facet',
  sourceSegmentFacet: 'source-segment-facet',
}

export const SOURCE_CHANNEL_OPTIONS: IFacetRadioGroupProps<ISourceChannel>['options'] = [
  {
    label: SOURCE_CHANNEL_LABELS.inbound_call,
    value: ISourceChannel.INBOUND_CALL,
  },
  {
    label: SOURCE_CHANNEL_LABELS.inbound_email,
    value: ISourceChannel.INBOUND_EMAIL,
  },
  {
    label: SOURCE_CHANNEL_LABELS.outbound_call,
    value: ISourceChannel.OUTBOUND_CALL,
  },
  {
    label: SOURCE_CHANNEL_LABELS.outbound_email,
    value: ISourceChannel.OUTBOUND_EMAIL,
  },
]

export const SOURCE_SEGMENT_OPTIONS: IFacetRadioGroupProps<ISourceSegment>['options'] = [
  {
    label: SOURCE_SEGMENT_LABELS.dat,
    value: ISourceSegment.DAT,
  },
  {
    label: SOURCE_SEGMENT_LABELS.internal_recommendation,
    value: ISourceSegment.INTERNAL_RECOMMENDATION,
  },
  {
    label: SOURCE_SEGMENT_LABELS.relationship,
    value: ISourceSegment.RELATIONSHIP,
  },
  {
    label: SOURCE_SEGMENT_LABELS.carrier_app,
    value: ISourceSegment.CARRIER_APP,
  },
  {
    label: SOURCE_SEGMENT_LABELS.other_loadboard,
    value: ISourceSegment.OTHER_LOADBOARD,
  },
]
